import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import Logo from "./Logo";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/auth", { replace: true });
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#111111" }}>
        <div className="text-center space-y-4">
          <Logo size="xl" className="mx-auto" />
          <p className="text-sm" style={{ color: "#6b6b6b" }}>{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  if (!user) return null;
  return <>{children}</>;
}
